import React from 'react'
import ButtonSmallIcon from '../../../../../../common/components/atom/ButtonSmallIcon/ButtonSmallIcon';
import useNavigationApp from '../../../../../../navigation/useNavigationApp';
import { useSingleWallet } from '../../../../hooks/useWallet';

export default function WalletsActionBtnPresenter() {
    const navigation = useNavigationApp();
    const {singleWalletQuery:{data: walletData}} = useSingleWallet()
  return (
    <WalletActionBtnView
    
    handleAddCredit={ walletData ? () => {
        navigation.goAddCreditWallet(walletData.wallet_user_orga_id, walletData.wallet_id);
    }: undefined}
    />
  )
}

export interface WalletActionBtnProps {
    handleAddCredit?: () => void;
    handleCreateNewPaygo?: () => void;
}

export const WalletActionBtnView = ({handleAddCredit, handleCreateNewPaygo} : WalletActionBtnProps) => {


    return(
        <div style={{display: "flex", gap: "10px", justifyContent: "center", alignItems: "center"}}>
            <div >
            <ButtonSmallIcon
                iconType="plus"
                label="Ajouter du crédit"
                variant="stack-rounded-icon"
                onClick={handleAddCredit || (() => {})}
                color='rgb(49, 49, 49)'
                iconSize={13}

            />
            </div>
            {/*
            <div >
            <ButtonSmallIcon
                iconType="coin"
                label="Créer un PayGo"
                variant="stack-rounded-icon"
                onClick={handleAddCredit || (() => {})}
                colorBackground="#A6E0EF"
                color='#0A7D9D'
            />
            </div>
            */}
        </div>
    )
}
